module.exports = __webpack_public_path__ + "static/theoffice-b446b82794aaf809c2a8bc3ec4251800.gif";